module.exports = __webpack_public_path__ + "stu-res/img/course-3.9dbe39e8.png";